module.exports = __webpack_public_path__ + "img/31.2bf5f800.png";